<template>
  <v-dialog v-model="isOpenDialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>SỬA THÔNG TIN TÀI KHOẢN NGÂN HÀNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-container>
        <v-col>
          <v-form ref="form" flat v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="bank"
                  :items="banks"
                  label="Ngân hàng"
                  item-text="shortName"
                  item-value="shortName"
                  no-data-text="Danh sách trống"
                  clearable
                  clear-icon="mdi-close"
                  dense
                  outlined
                  hide-details
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="accountNumber"
                  label="Số tài khoản"
                  placeholder="Nhập số tài khoản"
                  outlined
                  required
                  dense
                  class="required style"
                  :rules="[$rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="accountName"
                  label="Tên tài khoản"
                  placeholder="Nhập tên tài khoản"
                  outlined
                  required
                  dense
                  class="required style"
                  :rules="[$rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-container>
      <hr color="#E0E0E0" />
      <v-card-actions>
        <v-btn class="ma-2" outlined light @click="cancel" width="100px">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save" width="100px">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isObject } from 'lodash'

export default {
  data() {
    return {
      isOpenDialog: false,
      valid: true,
      studentId: '',
      banks: '',
      bank: {},
      oldBankData: {},
      accountNumber: '',
      accountName: '',
    }
  },
  computed: {
    ...mapGetters({
      classBankAccount: 'bankAccount/classBankAccount',
    }),
  },
  methods: {
    ...mapActions('students', ['updateStudent']),

    async openDialog(student, banks = []) {
      await this.getInfoBank(student.tuitionBank)
      this.banks = banks
      this.studentId = student._id
      this.isOpenDialog = true
    },
    cancel() {
      this.isOpenDialog = false
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    },
    async getInfoBank(tuitionBank) {
      this.bank = tuitionBank.bankCode
      this.accountNumber = tuitionBank.accountNumber
      this.accountName = tuitionBank.accountName
      this.oldBankData = tuitionBank
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          await this.updateBankAccount()
          this.$alert.success('Chỉnh sửa thành công')
          this.isOpenDialog = false
        } catch (error) {
          this.$alert.error(error)
        } finally {
          this.$loading.active = false
        }
      }
    },
    async updateBankAccount() {
      let params = {
        ...this.oldBankData,
        accountNumber: this.accountNumber,
        accountName: this.accountName,
      }
      if (isObject(this.bank)) {
        params.bankCode = this.bank.code
        params.bin = this.bank.bin
        params.bankName = this.bank.bankName
      }
      await this.updateStudent({ id: this.studentId, tuitionBank: params })
    },
    reset() {
      this.bank = ''
      this.accountNumber = ''
      this.accountHolder = ''
      this.oldBankData = {}
    },
  },
}
</script>
